export const Bio = {
  name: "Damilola Miracle Kolawole",
  roles: [
    "MERN Stack Developer",
    "Frontend Developer",
    "Programmer",
  ],
  description:
    "A highly skilled and detail-oriented Frontend Engineer with 2+ years of hands-on experience building and optimizing user-centric web applications using JavaScript, TypeScript, React.js, and Next.js. Proficient in translating UI/UX designs into code and improving web performance for smooth and responsive user experiences. Strong expertise in HTML5, CSS3, and responsive design principles, with a passion for delivering clean, maintainable, and scalable code.",
  github: "https://github.com/baouldguyd",
  resume:
    "https://drive.google.com/file/d/1NvqP4ruvyTbdhGs-bBHZkYlTNArarlY7/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/dammyceo",
  twitter: "https://twitter.com/dammy_ceo",
  insta: "https://www.instagram.com/dammyceo_",
  facebook: "https://facebook.com/20yearoldceo",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/2048px-Typescript_logo_2020.svg.png",
      },
      {
        name: "Next JS",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWOYMtSMKxVApuqB5E7IjY9KuS15wUF4jtYg&s",
      },
      {
        name: "Ant Design",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDFMkgc-3Ic_ulT8KOXJCkvQeLLUlgo9TpOg&s",
      },

    ],
  },
 
  {
    title: "Version Control & Tools",
    skills: [
      {
        name: "Git",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
      {
        name: "Figma",
        image:
          "data:image/png;base64,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",
      },

      {
        name: "Vercel",
        image:
          "https://cdn.worldvectorlogo.com/logos/vercel.svg",
      },
      {
        name: "Cloudinary",
        image:
          "https://cloudinary-marketing-res.cloudinary.com/image/upload/3-logo-brand-square.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://pbs.twimg.com/profile_images/1277870278215905287/3iAMOxdI_400x400.jpg",
    role: "Frontend Developer",
    company: "Awarri",
    date: "Nov 2023 - Present",
    desc: "Develop responsive, user-friendly interfaces using React.js and TypeScript, improving the user experience of AI-powered applications. •Collaborate with backend engineers to ensure seamless integration between front-end components and APIs. •Refactor code to enhance performance, scalability, and maintainability of existing projects. •Lead UI improvements based on user feedback, optimizing accessibility and usability.",
    skills: [
      "NEXT JS",
      "React JS",
      "GCP",
      "Typescript",
      "javascript",
      "Git/Github",
      "Communication",
      "Research and Development",
    ],
  },
  {
    id: 0,
    img: "https://www.afrilabs.com/wp-content/uploads/2023/08/Senator-Abiru-Innovation-Lab.jpg",
    role: "Frontend Developer",
    company: "SAIL Nigeria",
    date: "January 2023 - August 2023",
    desc: "•Developed customized web applications for small businesses using React.js, TypeScript, and Next.js, focusing on improving client brand visibility and user engagement. •Created responsive and SEO-friendly websites, optimizing them for faster loading times and improved performance metrics. •Collaborated directly with clients to gather requirements,provide feedback, and ensure timely delivery of projects. •Implemented third-party API integrations such as payment gateways, authentication services, and content management systems to enhance functionality.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Ant Design",
      "HTML",
      "CSS",
      "JavaScript",
      "REST API",
      "Next JS",
      "Typescript"
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTp448rBq-OHv_UkL8_KNFNexPtdgA4Z6r3Ww&s",
    company: "ISabi Technologies",
    role: "Frontend Developer",
    date: "October 2022 - December 2022",
    desc: "Learned about web development technologies, including HTML, CSS, frontend frameworks (e.g., React), and backend technologies (e.g., Node.js).Gained an understanding of working with databases, including designing schemas, and using database management systems (e.g., MongoDB). Learned programming languages commonly used, such as Html, Css, JavaScript and understood the syntax and implementing algorithms. Learned to use version control systems like Git to track changes to my code, collaborate with others, and manage different versions of my projects. Understood the importance of writing clean, maintainable, and efficient code. Learned about coding standards, naming conventions, and documentation practices that contribute to producing high-quality software.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Ant Design",
      "HTML",
      "CSS",
      "JavaScript",
      
    ],
  },
 
];



export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4rb9ogrlMPWjNJ5hKzFqBghoeqvckAGSrWw&usqp=CAU",
    school: "Sail Innovations Lab, Lagos",
    date: "Jan 2023 - Aug 2023",
    desc: "Learned about web development technologies, including HTML, CSS, frontend frameworks (e.g., React), and backend technologies (e.g., Node.js).Gained an understanding of working with databases, including designing schemas, and using database management systems (e.g., MongoDB). Learned programming languages commonly used, such as Html, Css, JavaScript and understood the syntax and implementing algorithms. Learned to use version control systems like Git to track changes to my code, collaborate with others, and manage different versions of my projects. Understood the importance of writing clean, maintainable, and efficient code. Learned about coding standards, naming conventions, and documentation practices that contribute to producing high-quality software.",
    degree: "Certification - FullStack Web Development",
    grade: "Excellent",
  },
  {
    id: 1,
    img: "https://www.halcyonhouse.org/wp-content/uploads/2021/03/utiva-800x800.png",
    school: "Utiva, Lagos",
    date: "Jan 2023 - Nov 2023",
    desc: "Learned programming languages commonly used, such as Html, Css, JavaScript, React as well as implementing and algorithms. Learned to use version control systems like Git to track changes to my code, collaborate with others, and manage different versions of my projects. Understood the importance of writing clean, maintainable, and efficient code. Learned about coding standards, naming conventions, and documentation practices that contribute to producing high-quality software.",
    degree: "Certification - Frontend Web Development",
    grade: "Excellent",
  },
  {
    id: 2,
    img: "https://copsun.org/wp-content/uploads/2022/03/ksu.jpg",
    school: "Kogi State University, Anyigba",
    date: "Jan 2013 - Jan 2019",
    desc: "I completed my tertiaty higher institution education at Rufus Giwa Polytechnic Owo Ondo state, where I studied Human Kinetics and Health Education.",
    grade: "Second Class Upper Hons",
    degree:
      "BSC - Human Kinetics and Health Education",
  },
];

export const projects = [
 
  {
    id: 0,
    title: "RealestateWebApp",
    date: "Sept 2023 - Oct 2023",
    description:
      "A mern stack web app that offers an efficient search tool to filter properties by location, price, size, and other key features, making it easier for buyers and renters to find their perfect home or commercial space. Users can create accounts to save favorite listings, schedule viewings, and directly contact agents.",
    image:
      "https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    tags: [
      "Eslint",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
    ],
    category: "web app",
    // github: "https://github.com/jimohsegun1/realestatefullstackapp",
    webapp: "https://realestatefullstackapp.vercel.app/",
  },

  {
    id: 2,
    title: "Langeasy AI, Awarri",
    date: "Nov 2023 - Present",
    description:
      "Help build Nigeria's largest and most inclusive multilingual AI model by contributing your voice and language skills to our LangEasy platform.",
    image:
      "https://149346090.v2.pressablecdn.com/wp-content/uploads/2024/06/Awarri-LangEasy-768x432.png",
    tags: ["Html", "Css", "Javascript"],
    category: "web app",
    // github: "https://github.com/jimohsegun1/battery-A.P.I",
    webapp: "https://www.langeasy.ai/",
  },
  {
    id: 2,
    title: "Isabi Technologies",
    date: "Oct 2022 - Nov",
    description:
      "We specialize in crafting cutting-edge websites and applications that resonate with your audience. Let us transform your vision into a captivating digital reality, setting your brand apart in the digital sphere.",
    image:
      "https://media-hosting.imagekit.io//45c76b1a7f544a27/nn2.png?Expires=1733655338&Key-Pair-Id=K2ZIVPTIP2VGHC&Signature=CndgrKcLUZg3PHw3Kk3TAFtp-iJnoyjfKBEt5TN-k9c8atpzshjJG2tdstw8T1EFUh~b5yt16mwQczuTjh9qgoLCQ87T4ZBqiQCSTVWtfVe7igWxZbP8jtrz89ihzzcXaFic3E9rbfTaxv3ha56UdfsJf5hNGAposbDdUttS6Yt07jmBP~Qp27hcowbdUMuNi8lmcz48y~OLh-eKEmQH36fc7nhLB17Op67x71vvrYlzXSVwC8Z9JbPoEjePtimH~HpzqW2~JCUWdam1Ybl5vudQUIRvt8QI5DfAKbWYkKi3QcH1Mqc0cEn3b3o8T0lSv78jM1vrLjmbiYkZwXYxow__",
    tags: ["Html", "Css", "Javascript", "Git"],
    category: "web app",
    // github: "https://github.com/jimohsegun1/sailweather_prjct",
    webapp: "https://isabi-tech.vercel.app/",
  },
  {
    id: 0,
    title: "Taylors Floors USA",
    date: "Nov 2023",
    description:
      "At Taylor's Floors Inc. We are passionate about transforming your spaces into works of art. With 25 years of experience in the flooring industry, we have become the trusted choice for homeowners and businesses alike. Our commitment to quality, craftsmanship, and customer satisfaction is what sets us apart..",
    image:
      "https://media-hosting.imagekit.io//9d3fd6df8f8b4805/nn.png?Expires=1733655117&Key-Pair-Id=K2ZIVPTIP2VGHC&Signature=uKURubvu1uFTss34mhfQ8VSHPDC9wXeZ9hZn4yC7Etm9QIFitbb9xFndfHE57OzADDy-4ntQuPTLeSnVWR0QGw1u2~2jOc5iS7hqYUV1ZyhDJSpo0vS~q7Ya59am0qr63SSLRhokosMNsUgV8yWO4xcuEXUi92yEJyIOXgz6t3F9Gl~bKrDkYL~UxcxMWUSIhdquQg2XcpW8NFksig7CFCXn7DeF-pmQvhdknvG6K79kFo~Ubcpx0iObdCR1eO-dR6WO43KHqxGy0d4D5GvHyUoIN9Mz~J10anFEZyh1srAqAMepHzAcsnupUV~Lp~RjqRMw4wAKjQKSZRvrE2HKew__",
    tags: ["React", "Tailwind", "MongoDb", "Express", "Node", "Git"],
    category: "web app",
    // github: "https://github.com/jimohsegun1/tourapp",
    webapp: "https://taylorsfloorsinc.vercel.app/",
  },
 
  
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];


